<div class="h-full flex flex-col min-h-0">
  <!-- HEADER -->
  <div class="flex gap-2 items-center mb-4 shrink-0">
    <app-input-buscador
      placeholder="Buscar cliente por nombre o teléfono"
      [(valor)]="busquedaCliente"
      class="flex-1"
      (presionaEnter)="onBuscarCliente()"
    />

    <app-button
      label="Nuevo Cliente"
      icon="bi bi-plus"
      variant="primary"
      (onClick)="modal_crear_cliente.set(true)"
    />
  </div>

  <!-- TABLA (SCROLL SOLO AQUÍ) -->
  <div class="flex-1 min-h-0 overflow-y-auto">
    <app-tabla
      [columnas]="columnasTabla"
      [accionesTemplate]="accionesTemplate"
      [datos]="paginacion()?.data || []"
      (editar)="onEditar($event)"
      (eliminar)="onEliminar($event)"
    />
  </div>

  <!-- FOOTER PAGINACIÓN FIJA -->
  @if (paginacion() != null) {
    <div class="shrink-0">
      <app-paginacion
        [items]="paginacion()!.data"
        [itemsPorPagina]="paginacion()!.size"
        [totalItems]="paginacion()!.total"
        (paginaCambiada)="cambiarPagina($event)"
      />
    </div>
  }
</div>
<!-- Template -->
<ng-template #telefonoTemplate let-row> {{ row.numero_celular | telefono }} </ng-template>
<ng-template #accionesTemplate let-row>
  <div class="flex gap-1 sm:gap-2">
    <app-button
      icon="bi bi-pencil"
      variant="info"
      [rounded]="true"
      ariaLabel="Editar"
      (onClick)="onEditar(row)"
      appTooltip="Editar"
      tooltipPosition="top"
    />
    <app-button
      icon="bi bi-trash"
      variant="danger"
      [rounded]="true"
      ariaLabel="Eliminar"
      (onClick)="onEliminar(row)"
      appTooltip="Eliminar"
      tooltipPosition="top"
    />
  </div>
</ng-template>
<!-- diaglos -->

<app-dialog
  header="Crear Cliente"
  [modal]="true"
  [(visible)]="modal_crear_cliente"
  (onHide)="modal_crear_cliente.set(false)"
  size="4xl"
>
  @if (modal_crear_cliente()) {
    <app-crear-cliente (cerrar)="modal_crear_cliente.set(false)" (crear)="onCrear($event)" />
  }
</app-dialog>

<app-dialog
  header="Editar Cliente"
  [modal]="true"
  [(visible)]="modal_editar_cliente"
  (onHide)="modal_editar_cliente.set(false)"
  size="4xl"
>
  @if (modal_editar_cliente() && clienteSeleccionado != null) {
    <app-editar-cliente [cliente]="clienteSeleccionado" (cerrar)="onCerrarEditar($event)" />
  }
</app-dialog>

<app-dialog
  header="Eliminar Cliente"
  [modal]="true"
  [(visible)]="modal_eliminar_cliente"
  (onHide)="modal_eliminar_cliente.set(false)"
  size="xs"
>
  <app-modal-confirmacion
    mensaje="¿Estás seguro que deseas eliminar al cliente?"
    textoCancel="Cancelar"
    textoConfirm="Si, eliminar"
    (confirmar)="eliminar()"
    (cancelar)="cerrarModalEliminar()"
  />
</app-dialog>
